import get from 'lodash/get';
import { PAYMENT_API_HOSTS } from '../utils/env';
import request from './request';
import requestJson from './requestJson';

export async function fetchCredits(env) {
  const endpoint = 'api/1/credits/campaigns/default';
  // TODO, delete try useless on this file
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await request(endpoint, 'GET', env);
    return response;
  } catch (err) {
    throw err;
  }
}

export async function fetchInvoicePreview(env, lineItems) {
  const host = get(PAYMENT_API_HOSTS, env);
  const url = `${host}/invoices/preview`;
  // eslint-disable-next-line no-useless-catch
  try {
    const response = await requestJson({
      url,
      method: 'POST',
      body: JSON.stringify(lineItems),
      headers: {
        'Content-Type': 'application/json',
      },
      env,
    });
    return response;
  } catch (err) {
    throw err;
  }
}
